import {
  handleAddMachinesBySwitch,
  handleMachineSelectAltBySwitch,
  handleMachineSelectWithSpecLocationAltBySwitch,
} from '../../../components/store/slices/masterControlBySwitchSelectSlice';
import {
  handleAddMachinesByLocation,
  handleMachineSelectAltByLocation,
  handleMachineSelectWithSpecLocationAltByLocation,
} from '../../../components/store/slices/masterControlSelectByLocationSlice';

export const selectMachineDispatchHandler = (
  dispatch,
  scope,
  name,
  extraOption,
  locationIdx,
  specLocationIdx,
  machineIdx,
  newSelectedMachine,
  select = true,
) => {

  if (scope === 'switch') {
    if (extraOption) {
      dispatch(
        handleMachineSelectWithSpecLocationAltBySwitch({
          controller: name,
          locationIdx,
          specLocationIdx,
          machineIdx,
          status: select,
        }),
      );
    } else {
      dispatch(
        handleMachineSelectAltBySwitch({
          controller: name,
          locationIdx,
          machineIdx,
          status: select,
        }),
      );
    }
    dispatch(
      handleAddMachinesBySwitch({
        controller: name,
        arr: newSelectedMachine,
      }),
    );
  } else {
    if (extraOption) {
      dispatch(
        handleMachineSelectWithSpecLocationAltByLocation({
          controller: name,
          locationIdx,
          specLocationIdx,
          machineIdx,
          status: select,
        }),
      );
    } else {
      dispatch(
        handleMachineSelectAltByLocation({
          controller: name,
          locationIdx,
          machineIdx,
          status: select,
        }),
      );
    }
    dispatch(
      handleAddMachinesByLocation({
        controller: name,
        arr: newSelectedMachine,
      }),
    );
  }
};
